'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (app) {
  app.directive('goScrollTop', function ($ionicScrollDelegate) {
    var TPL = '<div class="gotop hidden"><i class="ion ion-ios-arrow-thin-up"></i></div>';
    return {
      restrict: 'A',
      link: function link($scope, $element) {
        var el = (0, _dom.createElement)(TPL);
        (0, _dom.insertAfter)(el, $element[0]);
        angular.element(el).on('click', function () {
          $ionicScrollDelegate.scrollTop(true);
        });
        $element.on('scroll', (0, _throttle2.default)(function (e) {
          var scrollTop = 0;
          if ((0, _objectType.isNumber)(e.detail && e.detail.scrollTop)) {
            scrollTop = e.detail.scrollTop;
          } else if ((0, _objectType.isNumber)(e.srcElement && e.srcElement.scrollTop)) {
            scrollTop = e.srcElement.scrollTop;
          }
          if (scrollTop > window.screen.availHeight + 500) {
            el.classList.remove('hidden');
          } else {
            el.classList.add('hidden');
          }
        }, 300, false, true));
      }
    };
  });
  return app;
};

require('angular');

require('ionic');

var _dom = require('../../../utils/dom');

var _objectType = require('../../../utils/objectType');

var _throttle = require('../../../utils/throttle');

var _throttle2 = _interopRequireDefault(_throttle);

require('./index.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

; /**
   * 指令
   * goScrollTop ion-scroll 跳转到顶部
   */


//////////////////
// WEBPACK FOOTER
// ./src/lib/ionic1.x-common/directives/goScrollTop/index.js
// module id = 152
// module chunks = 0